export type FeatureDefinition = {
  name: string;
  label: string;
  description: string;
  area: string;
  ticket?: string;
  owner?: string;
  addedAt?: string;
  /** ISO date (YYYY-MM-DD). Past dates surface an "expired" warning in the dev panel. */
  expiresOn?: string;
};

export const FEATURE_DEFINITIONS = [
  {
    name: 'showAllSegmentationMetrixTab',
    label: 'Full segmentation matrix tabs',
    description: 'Shows or hides the full set of tabs in the segmentation matrix',
    area: 'Segmentation',
    ticket: '#4403',
  },
  {
    name: 'aggregatedScientificInformation',
    label: 'Aggregated Scientific Information',
    description:
      'Unlocks the Aggregated Scientific Information module under Aggregated Engagement. When off, the menu entry stays visible with a "Coming soon" chip and is not navigable.',
    area: 'Aggregated Scientific Information',
    ticket: '#5230',
  },
  {
    name: 'insightsHco',
    label: 'Insights HCO',
    description: 'Enables HCO-related insight data across the Insights page',
    area: 'Insights',
    ticket: '#5146',
  },
  {
    name: 'sales',
    label: 'Sales',
    description:
      'Unlocks the Sales module. When off, the top-level "Sales" navigation entry is hidden and the /sales routes render Not Found.',
    area: 'Sales',
    ticket: '#5504',
  },
  {
    name: 'hcoOverviewContentTabs',
    label: 'HCO Overview content tabs',
    description:
      'Enables Executive summary content on the HCO Overview page; when disabled, the tab stays visible with a "Coming soon" tooltip.',
    area: 'HCO360',
    ticket: '#5686',
  },
] as const satisfies readonly FeatureDefinition[];

export type FeatureName = (typeof FEATURE_DEFINITIONS)[number]['name'];

export const FEATURE_NAMES: readonly FeatureName[] = FEATURE_DEFINITIONS.map(definition => definition.name);

export const toEnvVarName = (featureName: string): string =>
  `VITE_FEATURE_${featureName.replace(/[A-Z]/g, letter => `_${letter}`).toUpperCase()}`;
